import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CurrencyNumber from "../../../components/UI/CurrencyNumber";
import moment from "moment";

const HighLevelDisclosure = ({
  showClause = [1, 2],
  includeTotalIncome,
  initialInvestment,
}) => {
  return (
    <Grid
      container={true}
      style={{ margin: "16px 0 0" }}
      className={"highLevelDisclosure"}
    >
      <Grid item={true} xs={12}>
        {includeTotalIncome && (
          <Typography
            className={"disclosure"}
            variant={"caption"}
            paragraph={true}
          >
            <sup>&dagger;</sup> Hypothetical{" "}
            <CurrencyNumber value={initialInvestment} /> investment. Income
            withdrawals taken quarterly. Source: Morningstar, Net of Fee,{" "}
            {moment().year()}.{" "}
            <i>Past performance does not guarantee future results.</i> Indices
            are unmanaged and cannot be invested indirectly.
          </Typography>
        )}
        {showClause.includes(1) && (
          <Typography className={"disclosure"} variant={"caption"} paragraph>
            <sup>*</sup> Performance for the Cy Optimized Portfolio is
            net of underlying fund fees and expenses, but does not reflect
            deduction of the adviser fee, platform fee or custodial fees.&nbsp;
            Cy Optimized Portfolio performance is hypothetical, does not represent
            actual results, and is not indicative of future returns. Please
            refer to the Important Information section at the end of this
            presentation for information about the limitations of hypothetical
            performance and the calculation methodology.
          </Typography>
        )}

        {showClause.includes(2) && (
          <Typography className={"disclosure"} variant={"caption"} paragraph>
            <sup>**</sup> Index performance does not reflect the deduction of
            fees. You cannot invest directly in an index.
          </Typography>
        )}

        {showClause.includes(3) && (
          <Typography className={"disclosure"} variant={"caption"} paragraph>
            <sup>***</sup> Performance type described as a "blend" indicates 
            that the Cy Optimized Portfolio performance shown is based 
            on a combination of the actual performance of the fund or investment 
            strategy (once actual performance is available) and index or backtested 
            performance for the time period prior to the inception of the fund or 
            investment strategy.
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default HighLevelDisclosure;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/HighLevelDisclosure.jsx